import { useUserStore } from "@/shared/store/user";
import {
    SamlState,
    LoginMethod
} from "@/shared/types";
import { CognitoAuth as Auth } from "@/shared/api/auth";
import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";
export const initialState: SamlState = {
    provider: null
};

export const useSamlStore = defineStore("saml", {
    persist: {
        storage: localStorage,
        paths: storeHelper.getStoragePaths("saml"),
    },
    state: (): SamlState => (_.cloneDeep(initialState)),
    getters: {
        storedProvider: state => state.provider,
    },
    actions: {
        setProvider (newProvider: string) {
            this.provider = newProvider;
        },
        getTokens (code: string): Promise<void> {
            const userStore = useUserStore();
            return UserService.samlToken(code)
                .then(result => {
                    userStore.activeUserPing();
                    userStore.setLoginMethod(LoginMethod.Sso);
                    // trigger login call from here
                    const { username, accessToken, idToken, refreshToken } = result.data;
                    Auth().setSignInUserSession(username, accessToken, idToken, refreshToken)
                        .then(user => userStore.processLogin(user as any));
                })
                .catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        setTokens (data): Promise<any> {
            const userStore = useUserStore();
            userStore.activeUserPing();
            userStore.setLoginMethod(LoginMethod.Sso);
            const { username, accessToken, idToken, refreshToken } = data;
            return Auth().setSignInUserSession(username, accessToken, idToken, refreshToken)
                .then(user => userStore.processLogin(user as any));
        },
        updateProvider (provider: string): void {
            this.setProvider(provider);
        },
    }
});
